/** @format */

// NOTE: this keeps the access token in LocalStorage just because it's simpler
// but in a real application you may want to use cookies instead for better security

let loginUrl;

if (process.env.NODE_ENV === 'development') {
  loginUrl = `https://gql.gpson.cz:3000/login`;
} else {
  loginUrl = `https://gql.gpson.cz:3000/login`;
}

class LoginHandler {
  getAccessToken({reset}) {
    let token = localStorage.getItem('accessToken');
    this.accessToken = token;
    return token;
  }

  getEmail() {
    let email = localStorage.getItem('email');
    return email;
  }

  async login(email, password) {
    let that = this;
    const response = await fetch(loginUrl, {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({email, password}),
    });
    if (response.ok) {
      const {token} = await response.json();
      that.accessToken = token;
      localStorage.setItem('accessToken', token);
      localStorage.setItem('email', email);
    }
    return response.ok;
  }

  isLoggedIn() {
    return !!localStorage.getItem('accessToken');
  }

  async logout({config, reason} = {}) {
    this.accessToken = null;
    localStorage.removeItem('accessToken');

    if (config && config === 'no-reload') {
      return;
    }
    if (this.redirecting) return;
    this.redirecting = true;
    window.location.replace(reason==='session-expired' ? '/#/login?reason=session-expired' : '/#/');
    window.location.reload(true);
  }
}

export default LoginHandler;
